import { useEffect } from "react";

const DEFAULT_TITLE = "Libreria del Colegio | Mayorista de libreria y papeleria escolar y comercial en Bahía Blanca desde 1982. | www.libreriadelcolegio.com";

/**
 * Pone "Libreria del Colegio | <title>" como título de la pestaña mientras
 * el componente está montado, y lo devuelve al título por defecto del sitio
 * al desmontarse (al navegar a otra pantalla).
 */
export default function useDocumentTitle(title) {
  useEffect(() => {
    if (title) {
      document.title = `Libreria del Colegio | ${title}`;
    }
    return () => {
      document.title = DEFAULT_TITLE;
    };
  }, [title]);
}
